import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'
import { css } from '@emotion/react'
import { useState } from 'react'
import { MediaQuery } from './Utility'



const carousel = (slider) => {
    const z = 300
    function rotate() {
        const deg = 360 * slider.track.details.progress
        slider.container.style.transform = `translateZ(-${z}px) rotateY(${-deg}deg)`
    }
    slider.on('created', () => {
        const deg = 360 / slider.slides.length
        slider.slides.forEach((element, idx) => {
            element.style.transform = `rotateY(${deg * idx}deg) translateZ(${z}px)`
        })
        rotate()
    })
    slider.on('detailsChanged', rotate)
}

export default function MiscCarousel({ children }) {
    const [currentSlide, setCurrentSlide] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [sliderRef, instanceRef] = useKeenSlider(
        {
            loop: true,
            controls: true,
            selector: '.carousel__cell',
            renderMode: 'custom',
            mode: 'free-snap',
            initial: 0,
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel)
            },
            created() {
                setLoaded(true)
            },
        },
        [carousel]
    )
    const mainStyle = css`

        [class^="number-slide"],
        [class*=" number-slide"] {
            background: grey;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 50px;
            color: #fff;
            font-weight: 500;
            height: 200px;
            max-height: 100vh;
        }
        .wrapper {
            display: flex;
            justify-content: center;
        }
        .scene {
            width: 240px;
            height: 130px;
            perspective: 90px;
            position: relative;
        }
        .scene .carousel.keen-slider {
            width: 100%;
            height: 100%;
            position: absolute;
            overflow: visible;
            transform: translateZ(-288px);
            transform-style: preserve-3d;
        }
        .carousel__cell {
            position: absolute;
            width: 200px;
            left: 20px;
            height: 130px;
            border: 1px solid rgba(0, 0, 0, 0.3);
        }

        
        .dots {
            display: flex;
            padding: 10px 0;
            justify-content: center;
        }
        
        .dot {
            border: none;
            width: 10px;
            height: 10px;
            background: #c5c5c5;
            border-radius: 50%;
            margin: 0 5px;
            padding: 5px;
            cursor: pointer;
        }
        
        .dot:focus {
            outline: none;
        }
        
        .dot.active {
            background: #000;
        }
        
        .arrow {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            fill: #fff;
            cursor: pointer;
        }
        
        .arrow--left {
            left: 5px;
        }
        
        .arrow--right {
            left: auto;
            right: 5px;
        }
        
        .arrow--disabled {
            fill: rgba(255, 255, 255, 0.5);
        }
        
        ${MediaQuery('md', 'min')} {
            .scene {
                width: 310px;
                height: 192px;
                perspective: 1000px;

            }
            .carousel__cell {
                position: absolute;
                width: 280px;
                left: 20px;
                height: 192px;
            }
        }
  
`

    return (
        <>
            <div css={mainStyle}>
                <div className="wrapper">
                    <div className="scene">
                        <div className="carousel keen-slider" ref={sliderRef}>
                            {children}
                        </div>
                    </div>
                </div>
                {loaded && instanceRef.current && (
                    <>
                        <Arrow
                            left
                            onClick={(e) =>
                                e.stopPropagation() || instanceRef.current?.prev()
                            }
                            disabled={currentSlide === 0}
                        />

                        <Arrow
                            onClick={(e) =>
                                e.stopPropagation() || instanceRef.current?.next()
                            }
                            disabled={
                                currentSlide ===
                                instanceRef.current.track.details.slides.length - 1
                            }
                        />
                    </>
                )}
            </div>
            {loaded && instanceRef.current && (
                <div className="dots">
                    {[
                        ...Array(instanceRef.current.track.details.slides.length).keys(),
                    ].map((idx) => {
                        return (
                            <button
                                key={idx}
                                onClick={() => {
                                    instanceRef.current?.moveToIdx(idx)
                                }}
                                className={'dot' + (currentSlide === idx ? ' active' : '')}
                            ></button>
                        )
                    })}
                </div>
            )}
        </>
    )
}


function Arrow(props) {
    const disabeld = props.disabled ? ' arrow--disabled' : ''
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${props.left ? 'arrow--left' : 'arrow--right'
                } ${disabeld}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            {props.left && (
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            )}
            {!props.left && (
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
            )}
        </svg>
    )
}

